let _config = null

export const registerAnalyticsConfig = analyticsConfig => {
  _config = analyticsConfig
}

export const getAnalyticsConfig = () => _config
